/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Noah Britt",
  title: "Hi, I'm Noah",
  subTitle: emoji(
    "Technical Lead at Ascendancy building Nora, your own Chief Network Officer"
  ),
  resumeLink:
    "https://drive.google.com/file/d/10InuSPHLxSLCrwRgxrrld78V2jwo2asO/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/nbritt27",
  linkedin: "https://www.linkedin.com/in/noah-britt-31b3a6190",
  gmail: "nbritt27@gmail.com",

  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "",
  skills: [
    emoji(
      "⚡ Building Nora, your own personal Chief Network Officer, an AI agent that manages and grows your professional network"
    ),
    emoji("⚡ Conduct Long-term research on workforce development and technological adaptation"),
    emoji(
      "⚡ Utilize network and statistical analyses to identify connections and communities"
    ),
    emoji(" Click any skill in the graph to learn more!")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Clemson University",
      logo: require("./assets/images/clemsonLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "January 2023 - May 2024",
      desc: "Received several academic publications with a GPA of 3.59",
      descBullets: [
        "Emphasis in data analysis and infomatics",
        "Courses included Advanced Machine Learning, Data Mining, and Scientific Visualization"
      ]
    },
    {
      schoolName: "Clemson University",
      logo: require("./assets/images/clemsonLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "August 2019 - December 2022",
      desc: "Took courses about Software Engineering, Web Development, and Machine Learning with a GPA of 3.93",
      descBullets: ["Also received a Minor in Global Poltics"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {

  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Technical Lead",
      company: "Ascendancy",
      companylogo: require("./assets/images/ascendancy_logo.png"),
      date: "October 2025 – Present",
      desc: "Building Nora, your own personal Chief Network Officer.",
      descBullets: [
        "For more information, check out our website at <a href='https://ascendancy.co'>https://ascendancy.co</a>"
      ]
    },
    {
      role: "CTO",
      company: "Social Slooth",
      companylogo: require("./assets/images/slooth_logo.png"),
      date: "August 2024 – August 2025",
      desc: "Built OSPREY, a comprehensive platform for AI-driven social media and open-source investigations.",
      descBullets: [
        "For more information, check out our website at <a href='https://socialslooth.com'>https://socialslooth.com</a>"
      ]
    },
    {
      role: "Data Scientist",
      company: "Social Media Listening Center",
      companylogo: require("./assets/images/smlcLogo.png"),
      date: "January 2020 – January 2021",
      desc: "Worked on specialized programs to automate social media mining and analysis for various clients.",
      descBullets: [
        "Automated social media mining and analysis models using Python and D3 visualization libraries. ",
        "Applied network graph theory to create community detection and contagion models for industry and government clients.",
        "Created visualization pipelines for real-time Twitter analysis of key “hot point” events."
      ]
    },
    {
      role: "Researcher",
      company: "NSF WEAVE",
      companylogo: require("./assets/images/weave_logo_large.png"),
      date: "January 2021 – Present",
      desc: "Worked with a team to explore the workforce impacts of autonomous vehicles.",
      descBullets: [
        "Specialized in sociological research on workforce impacts of autonomous vehicles.",
        "Utilized quantitative data analysis using machine learning and clustering-based topic modeling to aggregate and analyze thematic social media data, specifically on public and within-industry views in the transportation industry towards autonomous adoption. ",
        "Applied network graph theory with qualitative and quantitative data collection for analysis of social networks to complement existing structured and unstructured models.",
      ]
    },
    {
      role: "Product Specialist",
      company: "Dream Center",
      companylogo: require("./assets/images/dream_center_logo.jfif"),
      date: "June 2020 – Present",
      descBullets: [
        "Worked on a product deployment team at the head storefront.",
        "Used logistic regression and Bayesian models to predict future growth and seasonal changes for planning product deployments.",
        "Applied transport loading and scheduling optimization algorithms to improve the organization's method for truck pickups and deliveries."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Independent Projects",
  projects: [
    {
      image: require("./assets/images/marat_sample_output.png"),
      projectName: "Marat - Agent-Based Data Analysis Platform",
      projectDesc: "Marat ('muh-RAH') is a data analysis and visualization tool using a NextJS flowchart-style frontend to visualize and coordinate data analysis through Python-based Langgraph agents",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/nbritt27/marat-agent-data-analysis"
        }
        //  you can add extra buttons here.
      ]
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    
    {
      title: "Neo4j Certified Professional",
      image: require("./assets/images/Neo4j-logo_color.png"),
      imageAlt: "Neo4j Logo",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://graphacademy.neo4j.com/c/67a98e0f-3000-4292-98ee-24c379652689/"
        }
      ]
    },
    {
      title: "Neo4j Graph Data Science Certification",
      image: require("./assets/images/Neo4j-logo_color.png"),
      imageAlt: "Neo4j Logo",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://graphacademy.neo4j.com/c/498b651a-356e-4235-800e-7c5d9934769f/"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Manuscripts/Articles",
  subtitle:
    "A few samples of applying data concepts to understanding the real world :)",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://drive.google.com/file/d/1uIMyT25F0xm_vJWZUQ7R4mHprnXjGyNZ/view?usp=sharing",
      title: "Truck Drivers and Autonomous Trucks: A Topic Modeling Analysis of Truck Driver Posts",
      description: "This manuscript, accepted for presentation at the American Sociological Association Annual Conference, features a case methodology of clustering-based topic modeling to inform insights on autonomous adoption among truck drivers"
    },
    {
      url: "https://www.sciencedirect.com/science/article/pii/S0160791X23001185",
      title: "Will automated vehicles solve the truck driver shortages? Perspectives from the trucking industry",
      description:
        "We conducted a systematic literature review on autonomous vehicle deployment timelines, and generated a comprehensive overview of the existing legislative framework around autonomous adoption"
    },
    {
      url: "https://www.tandfonline.com/doi/full/10.1080/1369118X.2021.2020323",
      title: "Expendable to essential? Changing perceptions of gig workers on Twitter in the onset of COVID-19",
      description:
        "We conducted a thematic analysis of 23,845 Twitter posts to investigate changes in public percpetions of gig workers during before and during the Covid-19 pandemic, applying a custom machine learning model for mass coding of the entire dataset. Our results serve to inform policy and workforce changes regarding platform-based service companies."
    },
    {
      url: "https://drive.google.com/file/d/1SRi1Xlv1FbAndBCN_AwPqrvE4uvHdECv/view?usp=sharing",
      title: "Political Polarity and Discourse",
      description:
        "This paper uses clustering-based topic modeling along with OLS regression and lexicon-based sentiment analysis to expore the relationship between the dominance of conversation by a political group and the extremity of discourse on that topic."
    },
    {
      url: "https://blogs.clemson.edu/smlc/insurrection-at-the-capitol/",
      title: "Insurrection at the Capitol",
      description:
        "This blog post was intended to provide a brief overview of social media conversation following the January 6 insurrection in 2021."
    },
    {
      url: "https://drive.google.com/file/d/1sDET46OXitkHOVJi2-2Utqt_d_adwIdm/view?usp=sharing",
      title: "Analysis and Potential Contribution to BoTMoE Twitter Detection",
      description:
        "This internal analysis explored a potential improvement on the recently released BoTMoE algorithm, a framework for detecitng bots through a tri-modal algorithm."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {

  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {

  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Want to discuss a project or just want to chat? My Inbox is always open.",
  number: "864-915-4728",
  email_address: "nbritt27@gmail.com"
};

// Twitter Section

const twitterDetails = {

};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
